/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { inject as service } from '@ember/service';
import DS from 'ember-data';
import SubjectStepModel from 'cio/models/subject-step';
import Component from '@glimmer/component';

interface MultiSplitSignature {
  Element: HTMLDivElement;
  Args: {
    step: SubjectStepModel;
  };
}

export default class MultiSplit extends Component<MultiSplitSignature> {
  @service store!: DS.Store;

  get segment() {
    return this.args.step.action.belongsTo('segment').value();
  }
}
